import { useEffect, useState } from "react";
import { Item } from "../../../../../models/assessments";
import { Box, Paper, Stack, TextField, Typography } from "@mui/material";
import { isRichTextContentEmpty } from "../../../../../utils/rich-text-empty";
import { RenderRichText } from "../../../../../components/render-rich-text";

interface TheoryViewProps {
    item: Item;
    register: (id: string, getItem: () => Item) => void;
    setResource: React.Dispatch<React.SetStateAction<string>>;
}

export default function TheoryView({ item, register, setResource }: TheoryViewProps) {
    const [locItem, setLocItem] = useState<Item>({
        ...item,
        answer: item.answer ? item.answer : ''
    });

    const handleAnswerChange = (value: any) => {
        const updatedItem = { ...locItem, answer: value };
        setLocItem(updatedItem);
        register(item.id, () => updatedItem);
    };



    return (
        <Paper
            key={item.id}
            elevation={1}
            sx={{
                display: 'flex',
                flexDirection: 'column',
                p: 3,
                border: '1px solid #e0e0e0',
                borderRadius: 2,
                backgroundColor: '#fff',
                gap: 2
            }}
        >
            {(item.title || item.required || item.marks) && (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        {!isRichTextContentEmpty(item.title) && (
                            <RenderRichText jsonContent={item.title} />
                        )}
                        {(item.type !== 0 && item.required) && (
                            <Typography color="error">*</Typography>
                        )}
                    </Box>

                        <Typography variant="caption" color="text.secondary">
                        {item.marks} mark{item.marks !== 1 ? 's' : ''}
                    </Typography>
                </Box>
            )}

            {!isRichTextContentEmpty(item.description) && (
                <Box>
                    <RenderRichText jsonContent={item.description} />
                </Box>
            )}
            
            {item.resources?.length > 0 && (
                <Stack
                    direction="row"
                    spacing={1}
                    sx={{ overflowX: "auto",}}
                >
                    {item.resources.map((res, i) => {
                        const handleResourceClick = () => {
                            setResource(res);
                        };

                        return (
                            <Box
                                key={i}
                                component="img"
                                src={res}
                                alt={`resource-${i}`}
                                onClick={handleResourceClick}
                                sx={{
                                    width: 48,
                                    height: 48,
                                    objectFit: 'cover',
                                    borderRadius: 1,
                                    cursor: 'pointer',
                                    border: '1px solid #ccc',
                                }}
                            />
                        );
                    })}
                </Stack>
            )}
    
            <TextField
                value={locItem.answer}
                onChange={(e) => handleAnswerChange(e.target.value)}
                variant={item.type === 1 ? 'standard' : 'outlined'}
                fullWidth
                multiline
                minRows={item.type === 2 ? 3 : 1}
                maxRows={item.type === 2 ? 5 : 2}
            />


        </Paper>
    )
}
